import { plural } from '@cian/utils';

import { IBscParkingSchema, IBuildingSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

type IGetCommercialMultiAdsParkingsConfig = (
  building: IBuildingSchema | null,
  bscParkings: IBscParkingSchema[] | null | undefined,
) => [string, string] | null;

const title = 'Парковка';
const pluralForms: [string, string, string] = ['место', 'места', 'мест'];

export const getCommercialMultiAdsParkingsConfig: IGetCommercialMultiAdsParkingsConfig = (building, bscParkings) => {
  const placesCount = building?.parking?.placesCount;

  if (placesCount) {
    return [title, `${placesCount} ${plural(placesCount, pluralForms)}`];
  }

  /**
   * У объявления может быть несколько парковок (заносится через админку).
   * В таком случае делаем следующее:
   * 1) Смотрим в поле offer.building.parking.placesCount
   * 2) Если данные есть, то берем их
   * 3) Если данных нет, то смотрим в offerData.businessShoppingCenter.parkings
   * 4) Если там есть данные - считаем сумму парк. мест и выводим
   * 5) В противном случае отдаем null
   */
  if (bscParkings) {
    const parkingSpotsNumber = bscParkings.reduce((sum, { placesCount }) => (placesCount ? sum + placesCount : sum), 0);

    if (parkingSpotsNumber) {
      return [title, `${parkingSpotsNumber} ${plural(parkingSpotsNumber, pluralForms)}`];
    }
  }

  return null;
};
